import { authUsername } from './AuthStore';

export const updateAuthUsername = (value) => authUsername.update((oldValue) => value);
